import i18next from 'i18next';

export const getVerifyIdErrorString = (
  t: i18next.TranslationFunction<unknown, object, string>,
  type: string,
  tenantId?: string,
) => {
  switch (type) {
    case 'FeatureIsDisabled':
      return t('verifyIdFeatureIsDisabled');
    case 'ErrorGettingVerifiedId':
      return t('verifyIdErrorGettingVerifiedId');
    case 'GuestIsNotAllowedToIssueVerifiedId':
      return t('verifyIdGuestIsNotAllowedToIssueVerifiedId', { tenantId });
    case 'TenantNotOnboardedToVerifiedId':
      return t('verifyIdTenantNotOnBoardedToVerifiedId', { tenantId });
    case 'TenantDoesNotHaveVerifiedEmployeeContract':
      return t('verifyIdTenantDoesNotHaveVerifiedEmployeeContract', { tenantId });
    case 'TenantIsNotInAllowedToIssueVerifiedId':
      return t('verifyIdTenantIsNotInAllowedToIssueVerifiedId', { tenantId });
    case 'ErrorTooManyRequests':
      return t('verifyIdErrorTooManyRequests');
    default:
      return t('verifyIdUnknownError');
  }
};
